module.exports = __webpack_public_path__ + "assets/ic_camera2_w.b4409240.svg";